//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TransientObject.js";
let d=[[[0,"Name",1,0],[0,"TypeValue",0,0]],[[[],"Dispose",{},0,0],[["attributeProperty"],"AddProperty",{},1,0],[["attributeProperty"],"RemoveProperty",{},1,0],[["attributeProperty"],"HasProperty",{R_:{attributePropertyCheck:''}},1,0],[["numProperties"],"GetProperties",{R_:{properties:""}},0,0]],[]];
SPLM.Features.CustomAttribute = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.CustomAttribute";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.CustomAttribute.Type = Object.freeze({
    "Unknown" : "Unknown", "Expression" : "Expression", "ExpressionVla" : "ExpressionVla", "Tag" : "Tag", "TagVla" : "TagVla", "Bool" : "Bool", "BoolVla" : "BoolVla", "Integer" : "Integer", "IntegerVla" : "IntegerVla", "Double" : "Double", "DoubleVla" : "DoubleVla", "String" : "String", "StringVla" : "StringVla"});

SPLM.Features.CustomAttribute.Property = Object.freeze({
    "IsOutputAttribute" : "IsOutputAttribute", "IsOwnedAttribute" : "IsOwnedAttribute", "IsReferencingTargetBody" : "IsReferencingTargetBody", "MandatoryInput" : "MandatoryInput"});

export default SPLM;